import Vue from 'vue'
import Router from 'vue-router'
import loginRoutes from '@/modules/Authentication/router'
import signUpRoutes from '@/modules/SignUp/router'
import newOrganizationRoutes from '@/modules/NewOrganization/router'
import homeRoutes from '@/modules/Home/router'
import dayEndRoutes from '@/modules/DayEnd/router'
import locationRoutes from '@/modules/Location/router'
import settingsRoutes from '@/modules/Settings/router'
import inventoryRoutes from '@/modules/Inventory/router'
import contactRoutes from '@/modules/Contact/router'
import employeeRoutes from '@/modules/Employee/router'
import invoiceRoutes from '@/modules/Invoice/router'
import reportRoutes from '@/modules/Reports/router'
import stripeExpressRoutes from '@/modules/StripeExpress/router'
import reportViewRoutes from '@/modules/ReportView/router'
import Main from './modules/Layout/index.vue'
import { isNativeMobileApp, useLiveMobilePortal } from './mobile/runtime'
import { getSupportToken } from './modules/Authentication/supportSession'

const PageNotFound = () => import('./views/PageNotFound.vue')
const Support = () => import('./modules/Support/index.vue')
const Receipt = () => import('./views/Receipt.vue')
const MobileNotifications = () => import('./mobile/Notifications.vue')
const MobileReports = () => import('./mobile/Reports.vue')
const LivePortalHandoff = () => import('./mobile/LivePortalHandoff.vue')
const MobileShiftSummary = () => import('./mobile/ShiftSummary.vue')

Vue.use(Router);

let mainRoutes = []
mainRoutes = mainRoutes.concat(homeRoutes)
mainRoutes = mainRoutes.concat(dayEndRoutes)
mainRoutes = mainRoutes.concat(inventoryRoutes)
mainRoutes = mainRoutes.concat(locationRoutes)
mainRoutes = mainRoutes.concat(contactRoutes)
mainRoutes = mainRoutes.concat(employeeRoutes)
mainRoutes = mainRoutes.concat(settingsRoutes)
mainRoutes = mainRoutes.concat(invoiceRoutes)
mainRoutes = mainRoutes.concat(reportRoutes)
mainRoutes = mainRoutes.concat(stripeExpressRoutes)
mainRoutes.push({
  path: '/notifications',
  name: 'mobile-notifications',
  component: MobileNotifications,
  beforeEnter: (to, from, next) => isNativeMobileApp ? next() : next('/home'),
})
mainRoutes.push({
  path: '/mobile-reports',
  name: 'mobile-reports',
  component: MobileReports,
  beforeEnter: (to, from, next) => isNativeMobileApp ? next() : next('/home'),
})
mainRoutes.push({
  path: '/mobile-actions/shift/:id',
  name: 'mobile-shift-summary',
  component: MobileShiftSummary,
})

let routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    children: mainRoutes,
    redirect: { path: '/home' },
    beforeEnter: (to, from, next) => {
      if (!getSupportToken() && (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`) == null)) {
        console.log('No token was found') // eslint-disable-line
        next({
          path: '/login',
          params: { nextUrl: to.fullPath },
        })
      } else {
        next()
      }
    },
  },
  {
    path: '/mobile-handoff',
    name: 'mobile-handoff',
    component: LivePortalHandoff,
  },
  {
    path: '/support',
    name: 'support',
    component: Support,
  },
  {
    path: '/receipt',
    name: 'receipt',
    component: Receipt,
  },
  {
    path: '*',
    name: 'pagenotfound',
    component: PageNotFound,
  },
]

// Add login routes to the app.
routes = routes.concat(loginRoutes)
routes = routes.concat(signUpRoutes)
routes = routes.concat(newOrganizationRoutes)
routes = routes.concat(reportViewRoutes);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (!useLiveMobilePortal || to.path !== '/logout') return next()
  let finished = false
  const complete = () => { if (!finished) { finished = true; next() } }
  window.dispatchEvent(new CustomEvent('repairnest:before-app-logout', { detail: { complete } }))
  setTimeout(complete, 2000)
})

export default router
